export const SUN = 'SUN'
export const OPTICAL = 'OPTICAL'
export const CASE = 'CASE'
export const CLIPON = 'CLIPON'
export const GIFT_CARD = 'gift-cards'
export const KIT = 'KIT'
export const GIFTCARD = 'GIFTCARD'

export const ELECTRONICS = 'Electronics'
export const UPPERCASE_ELECTRONICS = ELECTRONICS.toUpperCase()
export const ROX_ELECTRONICS = 'ROX_Electronics'
export const UPPERCASE_ROX_ELECTRONICS = ROX_ELECTRONICS.toUpperCase()
export const LOWERCASE_ELECTRONICS = ELECTRONICS.toLowerCase()
export const LOWERCASE_ROX_ELECTRONICS = ROX_ELECTRONICS.toLowerCase()

export const ALL_ELECTRONICS_PRODUCT_TYPES = [
  ROX_ELECTRONICS,
  ELECTRONICS,
  UPPERCASE_ELECTRONICS,
  UPPERCASE_ROX_ELECTRONICS,
  LOWERCASE_ELECTRONICS,
  LOWERCASE_ROX_ELECTRONICS,
]

export const CHILD = 'CHILD'
export const ACCESSORIES = 'Accessories'
export const REMIXABLE = 'REMIXABLE'
export const PRESCRIPTION_SUNGLASSES = 'prescription-sunglasses'
export const REMIX = 'remix'
export const ROX_FRAME = 'ROX_FRAME'

export const RX = 'RX'
export const STD = 'STD'

export const NOT_AVAILABLE_EMAIL_ME = 'NOT_AVAILABLE_EMAIL_ME'
export const NOT_AVAILABLE_ONLINE = 'NOT_AVAILABLE_ONLINE'
export const NOT_FOR_SALE = 'Not-for-sale'
export const AVAILABLE = 'AVAILABLE'
export const AVAILABLE_ANALYTICS = 'Available'
export const PREORDER_AVAILABLE_ANALYTICS = 'Available-PreOrder'
export const OUT_OF_STOCK = 'Out-of-stock'
export const AVAILABLE_ONE_LEFT = 'Available-oneLeft'
export const AVAILABLE_TWO_LEFT = 'Available-twoLeft'
export const AVAILABLE_FEW_LEFT = 'Available-fewLeft'

export const CBS = 'CBS'
export const COMING_BACK_SOON = 'COMING_BACK_SOON'

export const CS = 'CS'
export const COMING_SOON = 'COMING_SOON'

export const SO = 'SO'
export const SOLD_OUT = 'SOLD_OUT'

export const PRIVATE = 'PRIVATE'
export const SEMIPRIVATE = 'SEMIPRIVATE'

export const EYEGLASSES = 'EYEGLASSES'
export const SUNGLASSES = 'SUNGLASSES'
export const ROX_LENS_PART_NUMBER_QUERY_PARAM = '?roxLensPartNumber'

export const SKIP_TO_ADDTOBAG = 'Skip to add to bag'

export const TRYLENS_TIP_1 = 'Press and hold ENTER to see the lens filter applied.'
export const TRYLENS_TIP_2 = 'Release ENTER to return to this view.'

export const MILLIMETER = 'mm'

export const TRY_LENSES_STATIC = '_Static'

export const POLARIZED = 'polarized'
export const NON_POLARIZED = 'non_polarized'

export const GIFTCARD_VIRTUAL_IDENTIFIER = '002GC'
export const GIFTCARD_VIRTUAL = 'Virtual'

export const IS_SEMIPRIVATE = 'Semiprivate'
export const PUBLIC = 'Public'

export const ON_MODEL = 'On model'
export const ALTERNATIVE = 'Alternative'
export const FULLWIDTH = 'Fullwidth'

export const HIGH_BRIDGE_FIT = 'high_bridge_fit'
export const LOW_BRIDGE_FIT = 'low_bridge_fit'

export const CHROMANCE = 'Chromance'
export const TRANSITIONS = 'Transitions®'

export const VIDEO_EXTENSIONS = ['.mpg', '.mp2', '.mpeg', '.mpe', '.mpv', '.mp4']

export const NARROW_FACE = 'Narrow'
export const AVERAGE_FACE = 'Average'
export const WIDE_FACE = 'Wide'
export const MOST_SOLD = 'Most Sold'

export const MIX_AND_MATCH_PARAM = 'startWithMandM'

export const PDP_CAT_ENTRY_PARAM = '$catalogEntryId'

export const NARROW_FACE_BREAKPOINT = 123
export const AVERAGE_FACE_MIN_BREAKPOINT = 128
export const AVERAGE_FACE_MAX_BREAKPOINT = 133
export const WIDE_FACE_BREAKPOINT = 138
export const EXTENDED_AVERAGE_FACE_MIN_BREAKPOINT = 122
export const EXTENDED_AVERAGE_FACE_MAX_BREAKPOINT = 139
export const EXTENDED_OOS_RANGE_SIZES = 130.75

export const INCHES = "''"

export const LOW_BRIDGE_LABEL = 'low_bridge_fit'
export const HIGH_BRIDGE_LABEL = 'high_bridge_fit'
